import * as React from 'react'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import { Button } from './button'
import { cn } from '../../lib/utils'

export type MobileFilterSheetProps = {
  open: boolean
  title: string
  cancelLabel: string
  applyLabel: string
  clearLabel: string
  onCancel: () => void
  onApply: () => void
  onClear: () => void
  children: React.ReactNode
  className?: string
}

export function MobileFilterSheet({
  open,
  title,
  cancelLabel,
  applyLabel,
  clearLabel,
  onCancel,
  onApply,
  onClear,
  children,
  className,
}: MobileFilterSheetProps) {
  return (
    <DialogPrimitive.Root
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onCancel()
      }}
    >
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-[70] bg-black/20" />
        <DialogPrimitive.Content
          className={cn(
            'fixed inset-0 z-[71] flex h-[100dvh] w-screen flex-col overflow-hidden bg-[var(--color-surface)] text-[var(--color-text)] outline-none',
            className,
          )}
          onPointerDownOutside={(event) => event.preventDefault()}
        >
          <header className="grid min-h-16 shrink-0 grid-cols-[1fr_auto_1fr] items-center gap-3 border-b border-[var(--color-border)] px-4 pt-[env(safe-area-inset-top)]">
            <Button
              type="button"
              variant="ghost"
              className="justify-self-start px-2 font-semibold text-[var(--color-text)]"
              onClick={onCancel}
            >
              {cancelLabel}
            </Button>
            <DialogPrimitive.Title className="text-center text-base font-semibold tracking-[-0.01em]">
              {title}
            </DialogPrimitive.Title>
            <Button
              type="button"
              variant="primary"
              className="min-w-20 justify-self-end px-4"
              onClick={onApply}
            >
              {applyLabel}
            </Button>
          </header>

          <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain">
            {children}
          </div>

          <footer className="shrink-0 border-t border-[var(--color-border)] bg-[var(--color-surface)] px-4 pb-[max(1rem,env(safe-area-inset-bottom))] pt-3">
            <Button
              type="button"
              variant="ghost"
              className="w-full text-[var(--color-text-muted)]"
              onClick={onClear}
            >
              {clearLabel}
            </Button>
          </footer>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  )
}
